import { Switch, Route } from "react-router-dom";
import Dashboard from "./Dashboard/index";
import MasterCatalogue from "./MasterCatalogue";
import CategorywiseProducts from "./MasterCatalogue/Categories/CategorywiseProducts/index";
// import AddProduct from "./AddProduct";
import CreateCollection from "./CreateCollection";
import SelectProducts from "./CreateCollection/SelectProducts/index";
import ViewCollection from "./CreateCollection/ViewCollectionTable/index";
import Success from "./AddProduct/Success";
import EditProduct from "./EditProduct/index";
import EditProductSuccess from "./EditProduct/EditProductSuccess";
import CollectionLink from "./CreateCollection/CollectionLink";
import AddNewProduct from "./AddNewProduct/index";
import NewTable from "./CreateCollection/ViewTable/index";
import EditNewProduct from "./AddNewProduct/EditProduct";
import ManageCategories from "./UserSettings/index";
import AddProductFromCategory from "./AddNewProduct/AddProductFromCategory";
import ProductDetails from "./ProductDetails/index";
import AllCatalogues from "./CatalogueHistory";
import BuyerActivityDetails from "./BuyerActivity/index";
import ProfileSettings from "./ProfileSettings";
import Can from "../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
import NotAllowed from "./NotAllowed";
import BuyerDetails from "./BuyerRecommendations/BuyerDetails";
import BuyerList from "./BuyerRecommendations/BuyerList/index"
import Prospects from "./Prospects";

import TableV2 from "./CreateCollection/TableV2";

export default function AppRoutes() {
  return (
    <Switch>
       <Route exact path="/buyer-list" component={BuyerList} />
       <Route exact path="/prospects" component={Prospects} />
      <Route exact path="/buyer-details/:id" component={BuyerDetails} />
      <Route path="/buyer-activity-details/:id">
        <BuyerActivityDetails />
      </Route>

<Route
        path="/catalogue-table/:id/:type?"
        render={(props) => (
          <Can
            I={PERMISSIONS.create_catalogues.slug}
            a={PERMISSIONS.create_catalogues.permissionType}
            passThrough
          >
            {(allowed) => (allowed ? <TableV2 {...props} /> : <NotAllowed />)}
          </Can>
        )}
      />

      <Route
        path="/catalogue-history"
        render={(props) => (
          <Can
            I={PERMISSIONS.view_catalogues.slug}
            a={PERMISSIONS.view_catalogues.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <AllCatalogues {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/add-new-product"
        render={(props) => (
          <Can
            I={PERMISSIONS.create_products.slug}
            a={PERMISSIONS.create_products.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <AddNewProduct {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/add-product/:name/:id"
        render={(props) => (
          <Can
            I={PERMISSIONS.create_products.slug}
            a={PERMISSIONS.create_products.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <AddProductFromCategory {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/add-product"
        render={(props) => (
          <Can
            I={PERMISSIONS.create_products.slug}
            a={PERMISSIONS.create_products.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <AddNewProduct {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/edit-product/:id"
        render={(props) => (
          <Can
            I={PERMISSIONS.update_products.slug}
            a={PERMISSIONS.update_products.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <EditNewProduct {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/master-catalogue/:key"
        render={(props) => (
          <Can
            I={PERMISSIONS.view_products.slug}
            a={PERMISSIONS.view_products.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <MasterCatalogue {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/master-catalogue"
        render={(props) => (
          <Can
            I={PERMISSIONS.view_products.slug}
            a={PERMISSIONS.view_products.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <MasterCatalogue {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />
      
      <Route
        path="/product-details/:id"
        render={(props) => (
          <Can
            I={PERMISSIONS.view_products.slug}
            a={PERMISSIONS.view_products.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <ProductDetails {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/categorywise-products/:name/:id"
        render={(props) => (
          <Can
            I={PERMISSIONS.view_products.slug}
            a={PERMISSIONS.view_products.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <CategorywiseProducts {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/create-collection"
        render={(props) => (
          <Can
            I={PERMISSIONS.create_catalogues.slug}
            a={PERMISSIONS.create_catalogues.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <CreateCollection {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/collection-link/:id"
        render={(props) => (
          <Can
            I={PERMISSIONS.create_catalogues.slug}
            a={PERMISSIONS.create_catalogues.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <CollectionLink {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/view-collection/:id/:type?"
        render={(props) => (
          <Can
            I={PERMISSIONS.create_catalogues.slug}
            a={PERMISSIONS.create_catalogues.permissionType}
            passThrough
          >
            {(allowed) => (allowed ? <NewTable {...props} /> : <NotAllowed />)}
          </Can>
        )}
      />

      <Route
        path="/select-products/:id"
        render={(props) => (
          <Can
            I={PERMISSIONS.create_catalogues.slug}
            a={PERMISSIONS.create_catalogues.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <SelectProducts {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route
        path="/buyer-activity-details/:id"
        render={(props) => (
          <Can
            I={PERMISSIONS.view_catalogues.slug}
            a={PERMISSIONS.view_catalogues.permissionType}
            passThrough
          >
            {(allowed) =>
              allowed ? <BuyerActivityDetails {...props} /> : <NotAllowed />
            }
          </Can>
        )}
      />

      <Route path="/add-product-success">
        <Success />
      </Route>
      <Route path="/edit-product-success">
        <EditProductSuccess />
      </Route>

      {/* <Route path="/view-collection/:id">
        <ViewCollection />
      </Route> */}

      <Route path="/profile-settings">
        <ProfileSettings />
      </Route>

      <Route path="/">
        <Dashboard />
      </Route>
    </Switch>
  );
}
